/* eslint-disable jsx-a11y/role-supports-aria-props */
import cx from 'classnames';
import { useAtom } from 'jotai';
import { FunctionComponent, ReactNode, useEffect, useRef } from 'react';
import Transition from 'react-transition-group/Transition';
import Sticky from 'react-sticky-el';

import {
  actualStepAtom,
  currentSelectionAtom,
  isCatMenuSelecionOpenAtom,
  selectedCatalogueSelectionAtom,
} from '../../../../state/selection';
import Chevrelon from '../../icons/cheverlon';

import classes from './menu-with-back.module.css';

type CollapsibleListProps = {
  items: Array<{
    header: ReactNode;
    content: ReactNode;
    key: string | number;
    disabled?: boolean;
    onOpen?: Function;
    isSelectedSlug?: boolean;
    categoryHasStock?: boolean;
    currentSelection: any;
    slug: any;
  }>;
  withGap: boolean;
  icon?: 'arrow' | 'plus';
  openAllResults?: boolean;
  showBorder?: boolean;
  currentSelection?: any;
  maxWidth?: any;
  maxHeight?: any;
};

const getIcon = (iconSide: 'left' | 'right' | undefined) => {
  return (
    <div className="px-4 py-2 m-auto">
      <Chevrelon
        className={cx(
          'shrink-0',
          'w-4',
          {
            'rotate-90': iconSide === 'left',
          },
          {
            '-rotate-90': iconSide === 'right',
          },
          'group-hover:text-brand-100',
          'group-active:text-neutral-80',
          'group-focus-within::text-neutral-80'
        )}
      />
    </div>
  );
};

const headerContent = (
  header: ReactNode,
  iconSide: 'left' | 'right' | undefined,
  selectedSlug: boolean | undefined,
  withGap: boolean,
  categoryHasStock: boolean | undefined,
  onClickFunction: any,
  index: number | undefined
) => {
  return (
    <>
      <div
        className={cx(
          'text-base',
          'font-bold',
          'grid',
          iconSide === 'left' ? 'grid-cols-[48px_1fr]' : 'grid-cols-[1fr_48px]',
          'justify-between',
          { 'py-4': withGap },
          'items-center',
          'focus:outline-none',
          {
            'bg-neutral-10 focus:bg-neutral-10': selectedSlug,
          },
          {
            'group hover:bg-brand-10 cursor-pointer text-neutral-80':
              categoryHasStock,
          },
          {
            'text-neutral-50 cursor-default': !categoryHasStock,
          }
        )}
        onClick={onClickFunction}
      >
        {iconSide === 'left' && getIcon(iconSide)}
        {header}
        {categoryHasStock && iconSide === 'right' && getIcon(iconSide)}
      </div>
    </>
  );
};

const MenuWithBack: FunctionComponent<CollapsibleListProps> = ({
  items,
  withGap = true,
  currentSelection,
}) => {
  const [, setIsMenuOpen] = useAtom(isCatMenuSelecionOpenAtom);
  const [actualStep, setActualStep] = useAtom(actualStepAtom);
  const [currentSelectedCategory, setCurrentSelectedCategory] =
    useAtom(currentSelectionAtom);
  const [baseSelectedCategory, setBaseSelectedCategory] = useAtom(
    selectedCatalogueSelectionAtom
  );

  const stepContent = (state) => {
    let selectedContentToDisplay = undefined;
    if (
      typeof currentSelectedCategory !== 'undefined' &&
      typeof currentSelectedCategory.index !== 'undefined' &&
      currentSelectedCategory.index >= 0
    ) {
      selectedContentToDisplay = items.find(
        (element) => element.key === currentSelectedCategory.index
      );
    } else {
      if (baseSelectedCategory) {
        selectedContentToDisplay = items.find(
          (element) => element.slug === baseSelectedCategory.category.slug
        );
      }
    }

    return (
      <>
        {/*<Sticky
          mode="top"
          boundaryElement=".mainContent"
          hideOnBoundaryHit={false}
          wrapperClassName="max-lg:px-4 w-full mx-auto container"
          stickyClassName={cx('!top-12 z-10 bg-white ')}
        >*/}
        {headerContent(
          selectedContentToDisplay?.header,
          'left',
          true,
          withGap,
          selectedContentToDisplay?.categoryHasStock,
          () => {
            setActualStep(0);
            setIsMenuOpen(false);
            setCurrentSelectedCategory(undefined);
          },
          undefined
        )}
        {/*</Sticky>*/}
        {selectedContentToDisplay?.content}
      </>
    );
  };

  useEffect(() => {
    if (currentSelection) {
      setBaseSelectedCategory(currentSelection);
      setIsMenuOpen(true);
      setActualStep(1);
    } else {
      setActualStep(0);
    }
  }, [currentSelection, setActualStep, setBaseSelectedCategory, setIsMenuOpen]);

  return (
    <div
      className={cx('transform transition-transform', {
        'translate-x-0': actualStep === 0,
        '-translate-x-full': actualStep === 1,
      })}
    >
      <div
        className={cx('flex flex-nowrap whitespace-nowrap', {
          'overflow-x-hidden': actualStep === 0,
        })}
      >
        <div className={cx('lg:h-full min-w-full')}>
          {items.map((element, index) => {
            return headerContent(
              element?.header,
              'right',
              element?.isSelectedSlug,
              withGap,
              element?.categoryHasStock,
              () => {
                if (!element?.categoryHasStock) {
                  return;
                }
                setCurrentSelectedCategory({
                  category: element?.header,
                  subCategory: '',
                  index,
                });
                setActualStep(1);
                setIsMenuOpen(true);
              },
              index
            );
          })}
        </div>
        <div className={cx('min-w-full', { hidden: actualStep === 0 })}>
          <div className={cx('')}>{stepContent('')}</div>
        </div>
      </div>
    </div>
  );
};

export default MenuWithBack;
